import { lazy } from "react";
import type { Path } from "react-router-dom";
import { generateEncodedPath } from "../../utils/generateEncodedPath";
import type { AppRouteObject } from "../../routes";

export type HelpDeskTab = "help-desk";

export type HelpDeskParams = {
  realm: string;
  tab?: HelpDeskTab;
};

const HelpDeskSection = lazy(() => import("../HelpDeskSection"));

export const HelpDeskRoute: AppRouteObject = {
  path: "/:realm/help-desk",
  element: <HelpDeskSection />,
  breadcrumb: (t) => t("Help Desk"),
  handle: {
    access: "view-events",
  },
};

export const HelpDeskWithRoute: AppRouteObject = {
  ...HelpDeskRoute,
  path: "/:realm/help-desk/:tab",
};

export const toHelpDesk = (params: HelpDeskParams): Partial<Path> => {
  const path = params.tab ? HelpDeskWithRoute.path : HelpDeskRoute.path;

  return {
    pathname: generateEncodedPath(path, params),
  };
};
